import { all } from "redux-saga/effects";

//public
import AuthenticationSaga from "./authentication/saga";
import settingsSaga from "./settings/saga";
import sectionSaga from "./section/saga";
import contactsSaga from "./contacts/saga";
import objectionsSaga from "./objections/saga";
import developerRequestsSaga from "./developerRequests/saga";

export default function* rootSaga() {
  yield all([
    AuthenticationSaga(),
    settingsSaga(),
    sectionSaga(),
    contactsSaga(),
    objectionsSaga(),
    developerRequestsSaga(),
  ]);
}
